import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Col, Row } from 'antd'
import classNames from 'classnames'

import { CreditCardDetails } from 'core/application/adminDashboard/companySettings/subscription/subscriptionDetails'

import Error from 'common/components/dataEntry/formik/FormItemError'

import { useBreakPoints } from 'common/hooks'

interface RenewalCreditCardFormProps {
  recurlyErrors: Map<string, string>
  paymentDetails: CreditCardDetails
}

const RenewalCreditCardForm: React.FC<RenewalCreditCardFormProps> = ({ recurlyErrors, paymentDetails }) => {
  const { t: translate } = useTranslation()
  const { isMd } = useBreakPoints()
  useEffect(() => {
    recurly.configure({
      style: {
        all: {
          height: '32px',
        },
        number: {
          placeholder: {
            content: 'XXXX XXXX XXXX ' + (paymentDetails.cardNumberLastFour || 'XXXX'),
          },
        },
        month: {
          placeholder: {
            content: paymentDetails.expirationMonth || 'MM',
          },
        },
        year: {
          placeholder: {
            content: paymentDetails.expirationYear || 'YYYY',
          },
        },
        cvv: {
          placeholder: {
            content: 'XXX',
          },
        },
      },
    })
  }, [])

  return (
    <form autoComplete="off" id="recurly-form">
      <Row className="form__row">
        <div
          className={classNames({
            flex_space_between: isMd,
          })}
        >
          <Col className="mb-8" md={7}>
            <label className="formik-field__input-label">{translate('general.first-name')}</label>
            <input
              type="text"
              data-recurly="first_name"
              className="ant-input"
              defaultValue={paymentDetails.firstName}
            />
            {recurlyErrors.get('first_name') ? <Error>{recurlyErrors.get('first_name')}</Error> : null}
          </Col>

          <Col className="mb-8" md={7}>
            <label className="formik-field__input-label">{translate('general.last-name')}</label>
            <input
              type="text"
              data-recurly="last_name"
              defaultValue={paymentDetails.lastName}
              className="ant-input input__no-autofill-color"
            />
            {recurlyErrors.get('last_name') ? <Error>{recurlyErrors.get('last_name')}</Error> : null}
          </Col>

          <Col className="mb-8" md={7}>
            <label className="formik-field__input-label">
              {translate('admin-signup.subscription.payment.card-number-label')}
            </label>
            <div data-recurly="number" className="container"></div>
            {recurlyErrors.get('number') ? <Error>{recurlyErrors.get('number')}</Error> : null}
          </Col>
        </div>
      </Row>

      <Row className="form__row ">
        <div
          className={classNames({
            flex_space_between: isMd,
          })}
        >
          <Col className="mb-8" md={7}>
            <label className="formik-field__input-label">
              {translate('admin-signup.subscription.payment.expiration-month-label')}
            </label>
            <div data-recurly="month" className="container"></div>
            {recurlyErrors.get('month') ? <Error>{recurlyErrors.get('month')}</Error> : null}
          </Col>

          <Col className="mb-8" md={7}>
            <label htmlFor="bankName" className="formik-field__input-label">
              {translate('admin-signup.subscription.payment.expiration-year-label')}
            </label>
            <div data-recurly="year" className="container"></div>
            {recurlyErrors.get('year') ? <Error>{recurlyErrors.get('year')}</Error> : null}
          </Col>

          <Col md={7} className="mb-8">
            <label className="formik-field__input-label">
              {translate('admin-signup.subscription.payment.cvv-label')}
            </label>
            <div data-recurly="cvv" className="container"></div>
            {recurlyErrors.get('cvv') ? <Error>{recurlyErrors.get('cvv')}</Error> : null}
          </Col>
        </div>
      </Row>
      <input type="hidden" name="recurly-country" data-recurly="country" value="US" />
      <input type="hidden" name="recurly-token" data-recurly="token" />
    </form>
  )
}

export default RenewalCreditCardForm
